"use strict";

exports.__esModule = true;

require('./avatar.css');

exports.default = {
  "avatar": "pf-c-avatar"
};